module.exports = vendor_lib;


//////////////////
// WEBPACK FOOTER
// external "vendor_lib"
// module id = 12
// module chunks = 2